import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import withStyles, { css } from '@bd/bdui-styles';

const defaultStyles = css`
  &.FavoritesStatus {
    border-right: 1px solid #333333;
    transition: bottom 1s ease;
    color: #FFFFFF;
    opacity:1;
    height:100%;

    @media (min-width: 991px) {
      right: 460px;
    }

    &-active {
      top: 0;
      opacity:1;
    }

    a {
      width:auto !important;
      text-transform:capitalize !important;
      font-variant-numeric: lining-nums !important;
       -moz-font-feature-settings: "lnum" !important;
       -webkit-font-feature-settings: "lnum" !important;
       font-feature-settings: "lnum" !important;
       font-weight:400 !important;
    }
  }
  .FavoritesStatus_totalCount {
    color: #FFFFFF;
    padding: 15px 20px 15px 25px;
    @media(min-width:992px){
      padding: 12px 20px 12px 25px;
    }
  }
  .FavoriteUser {
      display: none;
    @media(min-width: 620px){
      display:inline-block;
    }
  }
`;

function FavoritesStatus({ className, favorites, hide, user }) {
  const active = !hide && favorites.length > 0;

  return (
    <div className={`FavoritesStatus ${active ? 'FavoritesStatus-active' : ''} ${className}`}>
      <Link name="favorites">
        <div className="FavoritesStatus_totalCount"><img src="/images/icons/favorites-heart-full.svg" width="20" height="20" alt="Favorites" /> <strong>{favorites.length}</strong> <span className="FavoriteUser">&nbsp;|&nbsp;{get(user, 'name', 'Sign In')}</span></div>
      </Link>
    </div>
  );
}

FavoritesStatus.propTypes = {
  className: PropTypes.string,
  favorites: PropTypes.arrayOf(PropTypes.object),
  hide: PropTypes.bool,
  user: PropTypes.object,
};

FavoritesStatus.defaultProps = {
  className: undefined,
  favorites: [],
  hide: false,
  user: undefined,
};

export default withData(
  {
    favorites: true,
    user: true,
  },
  {
    required: {},
  },
)(withStyles(defaultStyles)(FavoritesStatus));



// WEBPACK FOOTER //
// ./src/components/Favorites/FavoritesStatus.js